// src/theme.js
import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ff69b4",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
    text: {
      primary: "#000000",
      secondary: "#ff69b4",
    },
  },
  overrides: {
    MuiFormControlLabel: {
      root: {
        marginLeft: "0px !important",
        marginRight: "0px !important",
      },
    },
    MuiInputBase: {
      root: {
        "&.Mui-disabled": {
          opacity: 0.6,
          cursor: "not-allowed",
          "& .MuiInputBase-input": {
            cursor: "not-allowed",
            WebkitTextFillColor: "rgba(255, 255, 255, 0.5)",
          },
        },
      },
      input: {
        "&.Mui-disabled": {
          cursor: "not-allowed",
          opacity: 0.6,
          WebkitTextFillColor: "rgba(255, 255, 255, 0.5)",
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "&.Mui-disabled": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255, 255, 255, 0.12)",
          },
        },
      },
    },
    MuiFilledInput: {
      root: {
        "&.Mui-disabled": {
          backgroundColor: "rgba(255, 255, 255, 0.04)",
        },
      },
    },
    MuiRadio: {
      root: {
        color: "#f06ec4",
        "&$checked": {
          color: "#f06ec4",
        },
      },
      colorSecondary: {
        "&$checked": {
          color: "#f06ec4",
        },
      },
    },
    //calendars
    MuiPickersDay: {
      day: {
        color: "#fff",
      },
      daySelected: {
        backgroundColor: "#1976d2",
        color: "#fff",
      },
      dayDisabled: {
        color: "rgba(255,255,255,0.3)",
      },
    },
    MuiTypography: {
      body1: {
        color: "#fff", // month and year
      },
      caption: {
        color: "#fff", // week days
      },
    },
    MuiIconButton: {
      root: {
        color: "#fff", // white arrow icons
      },
    },
    MuiSvgIcon: {
      root: {
        color: "#fff", // white icons
      },
    },
    MuiMenuItem: {
      root: {
        color: "#fff", // text in dropdowns
      },
    },
    MuiButton: {
      label: {
        color: "#fff", // white text on buttons
      },
    },
  },
  typography: {
    fontFamily: `"SF Pro Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    h6: {
      fontSize: "1.5vw",
      fontWeight: "bold",
      "@media (max-width: 768px)": {
        fontSize: "3vw",
      },
    },
    body1: {
      fontSize: "1.2vw",
      "@media (max-width: 768px)": {
        fontSize: "2.5vw",
      },
    },
    body2: {
      fontSize: "1vw",
      "@media (max-width: 768px)": {
        fontSize: "2vw",
      },
    },
  },
});

export default theme;
